import { defineStore } from "pinia";

export const loaderStore = defineStore("loaderStore", {
    state: () => ({
        loader: false,
    }),
    getters: {
        getLoaderState: (state) => state.loader,
    },
    actions: {
        handleLoader: function (loaderState) {
            this.loader = loaderState;
        }
    },
});